import { PersonalizedInsightsProps } from '@copilot/common/components/drawer/wrappers/contact/informationPanel/types';

import { PersonalizedInsightsSectionV2DrawerSection } from '../personalizedInsightsSectionV2/personalizedInsightsSectionV2DrawerSection';

/**
 * The personalized insight section of prospect info panel
 * @param props
 * @constructor
 */
export default function PersonalizedInsightsDrawerSection({
    onViewCommunicationStyleDetails,
    onAnalyzeCommunicationStyles,
    isLoadingData,
    communicationStyles,
}: PersonalizedInsightsProps) {
    return (
        <PersonalizedInsightsSectionV2DrawerSection
            communicationStyles={communicationStyles}
            isLoadingInsights={isLoadingData}
            onRequestInsights={onAnalyzeCommunicationStyles}
            onSeeMoreTips={onViewCommunicationStyleDetails}
        />
    );
}
